import type { KeyboardEventHandler } from 'react';
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  prefix: 'tw',
});

export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs));
};

// Overlay exit animations keep content mounted for Escape's keyup, which a reactstrap Modal would take as its own close
export const stopEscapeKeyUp = <T extends Element>(onKeyUp?: KeyboardEventHandler<T>): KeyboardEventHandler<T> => (e) => {
  if (e.key === 'Escape') {
    e.stopPropagation();
  }
  onKeyUp?.(e);
};
